// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/png/noise.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes fadeInMixin {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes fadeOutMixin {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  height: -webkit-fit-content;
  height: -moz-fit-content;
  height: fit-content;
  gap: var(--spacing_unit_3);
  padding: var(--spacing_unit_3) var(--spacing_unit_4);
}
.button .loader {
  border: 2px solid transparent;
  border-top: 2px solid;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}
.button.primary {
  background: linear-gradient(107.28deg, rgba(98, 36, 198, 0.8) 10.17%, rgba(66, 24, 133, 0.8) 86.14%);
  border: 1px solid rgba(255, 255, 255, 0.5);
  color: var(--color_neutral_0);
  -webkit-backdrop-filter: blur(16px);
          backdrop-filter: blur(16px);
  box-shadow: -2px -2px 20px 0px rgba(246, 240, 255, 0.2) inset;
  transition: all 0.3s ease-in-out;
  overflow: hidden;
  position: relative;
  position: relative;
}
.button.primary::after {
  content: "";
  position: absolute;
  inset: 0;
  z-index: -1;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: 0% 0%;
  background-size: 36.23046875px 36.23046875px;
  background-repeat: repeat;
  border-radius: 12px;
  opacity: 0.3;
}
.button.primary .loader {
  border-top-color: var(--color_neutral_0);
}
.button.primary svg {
  fill: var(--color_neutral_0);
}
.button.primary::before {
  content: "";
  position: absolute;
  inset: 0;
  z-index: -1;
  background: linear-gradient(107.28deg, #6224c6 10.17%, #421885 86.14%);
  transition: opacity 0.3s ease-in-out;
  opacity: 0;
}
.button.primary:disabled {
  background: var(--color_neutral_200);
  color: #9ba1ad;
  color: var(--color_neutral_500, #9ba1ad);
  box-shadow: none;
  cursor: not-allowed;
}
.button.primary:disabled .loader {
  border-top-color: #9ba1ad;
  border-top-color: var(--color_neutral_500, #9ba1ad);
}
.button.primary:disabled svg {
  fill: #9ba1ad;
  fill: var(--color_neutral_500, #9ba1ad);
}
.button.primary:not(:disabled):hover {
  border-color: #6b27d8;
  box-shadow: 0px 2px 4px 0px rgba(98, 36, 198, 0.5019607843);
}
.button.primary:not(:disabled):hover::before {
  opacity: 1;
}
.button.outlined {
  border: 1px solid var(--color_neutral_800);
  color: var(--color_neutral_800);
}
.button.outlined .loader {
  border-top-color: var(--color_neutral_800);
}
.button.outlined svg {
  fill: var(--color_neutral_800);
}
.button.outlined:disabled {
  cursor: not-allowed;
  pointer-events: none;
  opacity: 0.6;
}
.button.outlined:hover {
  background: var(--color_neutral_200);
}
.button.small {
  font-size: 12px;
}
.button.small .loader,
.button.small svg {
  width: 16px;
  height: 16px;
}
.button.medium {
  font-size: 14px;
}
.button.medium .loader,
.button.medium svg {
  width: 18px;
  height: 18px;
}
.button.large {
  font-size: 16px;
}
.button.large .loader,
.button.large svg {
  width: 20px;
  height: 20px;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/mixins.scss","webpack://./src/components/Button/index.scss"],"names":[],"mappings":"AAwCA;EACE;IACE,UAAA;ECvCF;EDyCA;IACE,UAAA;ECvCF;AACF;AD0CA;EACE;IACE,UAAA;ECxCF;ED0CA;IACE,UAAA;ECxCF;AACF;AAbA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,0BAAA;EAAA,uBAAA;EAAA,kBAAA;EACA,2BAAA;EAAA,wBAAA;EAAA,mBAAA;EACA,0BAAA;EACA,oDAAA;AAeF;AAZE;EACE,6BAAA;EACA,qBAAA;EACA,kBAAA;EACA,kCAAA;AAcJ;AAXE;EACI,oGAAA;EACA,0CAAA;EACA,6BAAA;EACA,mCAAA;UAAA,2BAAA;EACA,6DAAA;EACA,gCAAA;EACA,gBAAA;EACA,kBAAA;EDyCJ,kBAAA;AC3BF;AD4BE;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,yDAAA;EACA,0BAAA;EACA,4CAAA;EACA,yBAAA;EACA,mBAAA;EACA,YAAA;AC1BJ;AAvBM;EACE,wCAAA;AAyBR;AAtBM;EACE,4BAAA;AAwBR;AArBM;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,sEAAA;EACA,oCAAA;EACA,UAAA;AAuBR;AApBM;EACE,oCAAA;EACA,cAAA;EAAA,wCAAA;EACA,gBAAA;EACA,mBAAA;AAsBR;AApBQ;EACE,yBAAA;EAAA,mDAAA;AAsBV;AAnBQ;EACE,aAAA;EAAA,uCAAA;AAqBV;AAjBM;EACE,qBAAA;EACA,2DAAA;AAmBR;AAjBQ;EACE,UAAA;AAmBV;AAdE;EACE,0CAAA;EACA,+BAAA;AAgBJ;AAdI;EACE,0CAAA;AAgBN;AAbI;EACE,8BAAA;AAeN;AAZI;EACE,mBAAA;EACA,oBAAA;EACA,YAAA;AAcN;AAXI;EACE,oCAAA;AAaN;AATE;EACE,eAAA;AAWJ;AATI;;EAEE,WAAA;EACA,YAAA;AAWN;AAPE;EACE,eAAA;AASJ;AAPI;;EAEE,WAAA;EACA,YAAA;AASN;AALE;EACE,eAAA;AAOJ;AALI;;EAEE,WAAA;EACA,YAAA;AAON;;AAFA;EACE;IACE,yBAAA;EAKF;AACF","sourcesContent":["@mixin line-clamp($lines, $wordBreak: break-word) {\n  display: -webkit-box;\n  line-clamp: $lines;\n  -webkit-line-clamp: $lines;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  word-break: $wordBreak;\n}\n\n@mixin scrollbar(\n  $color: var(--color_neutral_200),\n  $colorHover: var(--color_neutral_400),\n  $colorActive: var(--color_neutral_500)\n) {\n  &::-webkit-scrollbar {\n    width: 7px;\n    height: 7px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: transparent;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: $color;\n    height: 80px;\n    border-radius: 50px;\n  }\n\n  &:hover {\n    &::-webkit-scrollbar-thumb {\n      background: $colorHover;\n    }\n  }\n\n  &::-webkit-scrollbar-thumb:active {\n    background: $colorActive;\n  }\n}\n\n@keyframes fadeInMixin {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n@keyframes fadeOutMixin {\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n\n@mixin fadeIn($timing, $length, $delay, $fill) {\n  animation: fadeInMixin $timing $length $delay;\n  animation-fill-mode: $fill;\n}\n\n@mixin fadeOut($timing, $length, $delay, $fill) {\n  animation: fadeOutMixin $timing $length $delay;\n  animation-fill-mode: $fill;\n}\n\n@mixin noise {\n  position: relative;\n  &::after {\n    content: '';\n    position: absolute;\n    inset: 0;\n    z-index: -1;\n    background-image: url('./assets/images/png/noise.png');\n    background-position: 0% 0%;\n    background-size: 36.23046875px 36.23046875px;\n    background-repeat: repeat;\n    border-radius: 12px;\n    opacity: 0.3;\n  }\n}\n\n@mixin scoped-excluded($selector, $exclude-class) {\n  :is(#{$selector}):not(:where(#{$exclude-class} *)) {\n    @content;\n  }\n}\n","@import 'src/mixins.scss';\n\n.button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 12px;\n  width: fit-content;\n  height: fit-content;\n  gap: var(--spacing_unit_3);\n  padding: var(--spacing_unit_3) var(--spacing_unit_4);\n\n\n  .loader {\n    border: 2px solid transparent;\n    border-top: 2px solid;\n    border-radius: 50%;\n    animation: spin 1s linear infinite;\n  }\n\n  &.primary {\n      background: linear-gradient(107.28deg, rgba(98, 36, 198, 0.8) 10.17%, rgba(66, 24, 133, 0.8) 86.14%);\n      border: 1px solid rgba(255, 255, 255, 0.5);\n      color: var(--color_neutral_0);\n      backdrop-filter: blur(16px);\n      box-shadow: -2px -2px 20px 0px #f6f0ff33 inset;\n      transition: all 0.3s ease-in-out;\n      overflow: hidden;\n      position: relative;\n      @include noise;\n\n      .loader {\n        border-top-color: var(--color_neutral_0);\n      }\n  \n      svg {\n        fill: var(--color_neutral_0);\n      }\n  \n      &::before {\n        content: '';\n        position: absolute;\n        inset: 0;\n        z-index: -1;\n        background: linear-gradient(107.28deg, #6224c6 10.17%, #421885 86.14%);\n        transition: opacity 0.3s ease-in-out;\n        opacity: 0;\n      }\n  \n      &:disabled {\n        background: var(--color_neutral_200);\n        color: var(--color_neutral_500, #9ba1ad);\n        box-shadow: none;\n        cursor: not-allowed;\n\n        .loader {\n          border-top-color: var(--color_neutral_500, #9ba1ad);\n        }\n  \n        svg {\n          fill: var(--color_neutral_500, #9ba1ad);\n        }\n      }\n  \n      &:not(:disabled):hover {\n        border-color: #6b27d8;\n        box-shadow: 0px 2px 4px 0px #6224c680;\n  \n        &::before {\n          opacity: 1;\n        }\n      }\n  }\n\n  &.outlined {\n    border: 1px solid var(--color_neutral_800);\n    color: var(--color_neutral_800);\n\n    .loader {\n      border-top-color: var(--color_neutral_800);\n    }\n\n    svg {\n      fill: var(--color_neutral_800);\n    }\n\n    &:disabled {\n      cursor: not-allowed;\n      pointer-events: none;\n      opacity: 0.6;\n    }\n\n    &:hover {\n      background: var(--color_neutral_200);\n    }\n  }\n\n  &.small {\n    font-size: 12px;\n\n    .loader,\n    svg {\n      width: 16px;\n      height: 16px;\n    }\n  }\n\n  &.medium {\n    font-size: 14px;\n\n    .loader,\n    svg {\n      width: 18px;\n      height: 18px;\n    }\n  }\n\n  &.large {\n    font-size: 16px;\n\n    .loader,\n    svg {\n      width: 20px;\n      height: 20px;\n    }\n  }\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
